import type { ReactNode } from 'react';

const backgrounds = {
  white: '#ffffff',
  gray: '#f9fafb',
  'brand-dark': '#1A1A2E',
} as const;

interface SectionProps {
  background: keyof typeof backgrounds;
  children: ReactNode;
}

export function Section({ background, children }: SectionProps) {
  const isDark = background === 'brand-dark';

  return (
    <section
      style={{
        backgroundColor: backgrounds[background],
        color: isDark ? '#ffffff' : undefined,
        padding: 'var(--spacing-3xl) var(--spacing-md)',
        scrollMarginTop: 'var(--header-height)',
      }}
    >
      {children}
    </section>
  );
}
